import { UserService } from './../../../core/user.service';
import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { OperationalParametric } from '../../../cliente/operationalParametric.model';
import { BackendService } from '../../../core/backend.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackService } from '../../../shared-services/snack.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { Cliente } from '../../../cliente/cliente.model';
import { User } from '../user.model';
import { Foto } from '../foto.model';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../../../core/api.service';
import { Parametric } from '../../../cliente/parametric.model';

@Component({
  selector: 'app-user-foto-upload',
  templateUrl: './user-foto-upload.component.html',
  styleUrls: ['./user-foto-upload.component.scss']
})
export class UserFotoUploadComponent implements OnInit {
  @Input() fotos: Foto[];
  @Input() estado: OperationalParametric;
  @Input() editable = false;

  private re = /(?:\.([^.]+))?$/;
  seleccionarArchivo = 'Foto del usuario*';
  tiposImagenes: Observable<OperationalParametric[]>;


  constructor(
    private userService: UserService,
    private backendService: BackendService,
    private snackService: SnackService,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private dialogService: DialogService) { }

  async ngOnInit() {
    this.getTiposImagenes();

    if (this.fotos.length === 0) {
      this.agregarImagen();
    }
    const imgs = [];
    this.fotos.forEach(i => {
      const img = new Foto(null);
      img.id = i.id;
      img.name = i.name;
      img.path = i.path;
      if (i.path && i.path.indexOf('http') < 0) {
       this.getImages(img);
      } else {
        img.url = i.path + i.name;
      }

      imgs.push(img);
    });
    this.fotos.splice(0);
    imgs.forEach(i => this.fotos.push(i));
  }

  async getImages(imagen: Foto) {
    await this.userService.getFotoById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.url = safeUrl;
    });
  }

  agregarImagen() {
    this.fotos.push(new Foto(undefined));
  }
  eliminarImagen(index: number) {
    if (this.fotos[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar la foto ' + this.fotos[index].name
       + '?')
      .then( res => {
        if (res) {
          this.deleteFromDb(this.fotos[index].id);
          this.fotos.splice(index, 1);
          if (this.fotos.length === 0) {
            this.fotos.push(new Foto(undefined));
          }
        }
      });
    } else {
      this.fotos.splice(index, 1);
    }
  }
  deleteFromDb(id: number) {
    this.backendService.delete(User.path + 'eliminar-foto/' + id);
  }
  addFile(event, index: number) {
    if (this.soloImagenes(event.target.files[0].name)) {
      this.fotos[index].file = event.target.files[0];
      this.fotos[index].path = event.target.files[0].name;
      this.fotos[index].name = event.target.files[0].name;
      this.fotos[index].id = undefined;

    }
  }

  soloImagenes(fileName: string) {
    let ext = this.re.exec(fileName)[1];
    ext = ext.toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'svg' && ext !== 'jpeg' && ext !== 'gif') {
      this.snackService.error('Solo estan permitidos archivos de tipo ".png", ".jpg", ".svg", ".jpeg", ".gif"');
      return false;
    }
    return true;
  }

  async getTiposImagenes() {
    this.tiposImagenes = await this.apiService.get(Parametric, Parametric.path + 'tipos_imagenes/', null);
  }

  private openWindow(img: Foto) {
    this.dialogService.imageViewer(img.name, '', img.url);
    // window.open(img.url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/security/user/user-foto-upload/user-foto-upload.component.ts